var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4478 19.9104L52.6497 30.7388C51.5878 32.0458 52.5179 34 54.2019 34H71.7981C73.4821 34 74.4123 32.0458 73.3503 30.7388L64.5522 19.9104C63.7518 18.9253 62.2482 18.9253 61.4478 19.9104Z",
    fill: "#5CC244"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassArrow);
export default __webpack_public_path__ + "static/media/compass_arrow.492681703953142774a2c3049d1c4a5c.svg";
export { ForwardRef as ReactComponent };